import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Crumb } from "src/components/Breadcrumb";
import Container from "src/components/layout/Container";
import LayoutHead from "src/components/layout/LayoutCompany/LayoutHead";
import LayoutSidebar from "src/components/layout/LayoutCompany/LayoutSidebar";
import LayoutFooter from "src/components/layout/LayoutFooter";
import Loader from "src/components/Loader";
import DemoAccountBanner from "src/components/promotion/banners/DemoAccountBanner";
import NoMandateBanner from "src/components/promotion/banners/NoMandateBanner";
import PausedBanner from "src/components/promotion/banners/PausedBanner";
import useAuth from "src/hooks/selectors/useAuth";
import useLayout from "src/hooks/useLayout";
import useWindowSize from "src/hooks/useWindowSize";

interface LayoutProps {
	children?: any;
	className?: string;
	actions?: any;
	title?: string;
	subtitle?: string;
	backUrl?: string;
	variant: "default" | "small" | "no-container" | "medium";
	breadcrumb?: Crumb[];
	hideNav?: boolean;
	loading?: boolean;
	head?: {
		children?: any;
	};
}

const Layout = ({
	children,
	title,
	subtitle,
	actions,
	backUrl,
	variant,
	breadcrumb,
	hideNav,
	loading,
	head,
}: LayoutProps) => {
	const location = useLocation();
	const { isPhone, isTablet } = useWindowSize();
	const { layout } = useLayout();

	const auth = useAuth();
	const hasNoMandate = !auth.has_mandate && !hideNav && auth.has_subscription;

	const hasPausedSubscription =
		auth.type === "company" &&
		auth?.company?.subscription?.paused_at &&
		auth.has_subscription &&
		!hideNav;

	useEffect(() => {
		if (!location?.hash) {
			// window.scrollTo(0, 0);
		} else {
			const element = document.getElementById(
				location.hash.replace("#", "")
			);
			if (element) {
				element.scrollIntoView({
					behavior: "smooth",
				});
			}
		}
	}, [location]);

	return (
		<div className="flex flex-1">
			{auth.type === "company" && auth.mode === "demo" && (
				<DemoAccountBanner />
			)}
			{!isPhone && !isTablet && !hideNav && <LayoutSidebar />}
			<div className="flex flex-1 bg-white flex-col w-full">
				{!hideNav && (
					<LayoutHead
						{...{
							title,
							subtitle,
							actions,
							backUrl,
							breadcrumb,
							children: head?.children,
						}}
					/>
				)}
				<Container
					{...{ variant }}
					className={`flex-1 flex flex-col ${
						hideNav && "mt-8"
					} overflow-auto `}
					style={{
						maxWidth: window.innerWidth - layout.navbar.size.width,
					}}
				>
					{!loading ? (
						<div className="flex flex-1 relative flex-col gap-4 pb-4">
							{/* {hasNoSubscription &&
								!promos?.includes("euro_subscription_deal") && (
									<NoSubscriptionBanner />
								)} */}
							{hasNoMandate && <NoMandateBanner />}
							{hasPausedSubscription && <PausedBanner />}
							{children}
						</div>
					) : (
						<div className="flex flex-1 justify-center items-center relative flex-col gap-4 pb-4">
							<Loader />
						</div>
					)}
				</Container>
				<LayoutFooter />
			</div>
		</div>
	);
};

Layout.defaultProps = {
	variant: "default",
};

export default Layout;
